import { urls } from '@ff-os/shared-utils/urls';
import { PdpState } from '../../store';
import { createAsyncAppThunk } from '../createAsyncAppThunk';
import { AuthorizeResult } from './authorizeResult';

export const authorizeNew = createAsyncAppThunk<void, AuthorizeResult>(
    'auth/new',
    async (_, thunkApi) => {

        const request = formatRequest(thunkApi.getState());
        const response = await fetch(urls.requestNewGrant, request);

        if (response.ok) {
            return await response.json() as AuthorizeResult;
        } else {
            throw new Error(`Auth error: ${urls.requestNewGrant} [${response.status}]`);
        }
    }
);

const formatRequest = (state: PdpState) => ({
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
        tenantId: state.tenant.id
    })
});